import React, { useContext } from 'react';
import { SystemContext } from '../contexts/SystemContext';
var SingleVideoBrowser = function (_a) {
    var video = _a.video;
    var image = video.pictures.sizes[2];
    var _b = useContext(SystemContext), selecting = _b.selecting, onSelect = _b.onSelect;
    return (React.createElement("div", { className: "w-90 p-1 border border-transparent border-solid rounded flex justify-center relative " + (selecting ? 'cursor-pointer hover:border-white' : 'cursor-default'), title: video.name, onClick: function () { return onSelect(video); } },
        React.createElement("img", { src: image.link, height: image.height, width: image.width }),
        React.createElement("div", { className: "absolute w-full h-10 bottom-0 bg-opacity-70 bg-black mb-1" }),
        React.createElement("div", { className: "absolute bottom-1 p-2 text-sm truncate max-w-full" }, video.name)));
};
export default SingleVideoBrowser;
